export default __webpack_public_path__ + "static/media/visita_v.0ed13807.png";